export const countTotalRatio = {
  count: 0,
  total: 0,
  ratio: 0
};

const initialState = {
  tickets: [],
  highlighted_tickets: [],
  
  connecting_live_tickets: false,
  connected_live_tickets: false,
  disconnected_live_tickets: false,
  error_live_tickets: false,

  stats: Object.assign({}, getDefaultStats()),
  chartDta: [],
  total_pages: 1
};

export default function TicketsReducer(state = initialState, action) {
  switch (action.type) {
    case ticketActions.set_tickets:
      return {
        ...state,
        ...action.data,
      };

    case ticketActions.update_highlighted:
      return {
        ...state,
        highlighted_tickets: action.data
      }

    case ticketActions.set_stats:
      return {
        ...state,
        stats: action.data
      };
      
    case ticketActions.set_chart:
      return {
        ...state,
        chartDta: action.data
       };

    case ticketActions.update_stats:
      return {
        ...state,
        stats: action.data
      };

    case ticketActions.connected_live_tickets:
      return {
        ...state,
        connected_live_tickets: true,
        disconnected_live_tickets: false,
        connecting_live_tickets: false,
        error_live_tickets: false
      };

    case ticketActions.connecting_live_tickets:
      return {
        ...state,
        connected_live_tickets: false,
        disconnected_live_tickets: false,
        connecting_live_tickets: true,
        error_live_tickets: false,
        highlighted_tickets: [],
      };
    case ticketActions.disconnected_live_tickets:
      return {
        ...state,
        connected_live_tickets: false,
        disconnected_live_tickets: true,
        connecting_live_tickets: false,
        error_live_tickets: false,
        highlighted_tickets: [],
      };
    case ticketActions.error_live_tickets:
      return {
        ...state,
        connected_live_tickets: false,
        disconnected_live_tickets: false,
        connecting_live_tickets: false,
        error_live_tickets: true,
        error_live_tickets_data: action.data
      };

    default:
      return state;
  }
}

export function getDefaultStats() {
  return {
    cc: {
      paid: { total: 0, count: 0, ratio: 0, seats: 0},
      cancelled: { total: 0, count: 0, ratio: 0 },
      total: 0,
      ratio: 0
    },
    cash: {
      paid: { total: 0, count: 0, ratio: 0, seats: 0},
      pending: { total: 0, count: 0, ratio: 0 },
      cancelled: { total: 0, count: 0, ratio: 0},
      total: 0,
      ratio: 0
    },
    //Net Revenue
    paid_total: 0,
    paid_count: 0,
    paid_seats: 0,

    //Cancelled bookings
    cancelled_total: 0,
    cancelled_count: 0,

    //cash pending bookings
    pending_total: 0,
    pending_count: 0,

    //All bookings (pending+confirmed)
    all_total: 0,
    all_count: 0
  };
}

export const ticketActions = {
  set_tickets: "tickets/SET_TICKETS",
  update_highlighted: "tickets/UPDATE_HIGHLIGHTED",
  set_stats: "tickets/SET_STATS",
  update_stats: "tickets/UPDATE_STATS",
  set_chart: "tickets/SET_CHART",

  // live tickets actions
  // update_live_tickets: "tickets/UPDATE_LIVE_TICKETS",
  // clear_live_tickets: "tickets/CLEAR_LIVE_TICKETS",

  connected_live_tickets: "tickets/CONNECTED_LIVE_TICKETS",
  connecting_live_tickets: "tickets/CONNECTING_LIVE_TICKETS",
  disconnected_live_tickets: "tickets/DISCONNECTED_LIVE_TICKETS",
  error_live_tickets: "tickets/ERROR_LIVE_TICKETS"
};
